/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Projects_Wizard_Loading_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connecting your new space to the selected projects." |
*
* @param {Linked_Projects_Wizard_Loading_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const linked_projects_wizard_loading_description = /** @type {((inputs?: Linked_Projects_Wizard_Loading_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Projects_Wizard_Loading_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein neuer Space wird mit den ausgewählten Projekten verbunden.")
	return /** @type {LocalizedString} */ ("Connecting your new space to the selected projects.")
});